import { type SeverityLevel } from './types';

export const AREA_OPTIONS = [
  'Manager',
  'Scheduler',
  'Reports',
  'Funnel',
  'Onboarding',
  'Auth / Account',
  'Other',
] as const;

export const MANAGER_SUB_AREAS = [
  'Dashboard',
  'Projects',
  'Reports',
  'Clients',
  'Events',
  'Tasks',
  'KickOffs',
  'Agent',
  'Company Settings',
  'Permissions Management',
  'Resources Management',
  'Tags Management',
  'Welcome',
  'Other',
] as const;

export interface SeverityStyle {
  label: string;
  dotColor: string;
  activeBg: string;
  activeBorder: string;
  activeText: string;
}

export const SEVERITY_CONFIG: Record<SeverityLevel, SeverityStyle> = {
  Low: {
    label: 'Low',
    dotColor: '#10b981',
    activeBg: '#10b981',
    activeBorder: '#10b981',
    activeText: '#ffffff',
  },
  Medium: {
    label: 'Medium',
    dotColor: '#f59e0b',
    activeBg: '#f59e0b',
    activeBorder: '#f59e0b',
    activeText: '#ffffff',
  },
  High: {
    label: 'High',
    dotColor: '#f97316',
    activeBg: '#f97316',
    activeBorder: '#f97316',
    activeText: '#ffffff',
  },
  Critical: {
    label: 'Critical',
    dotColor: '#ef4444',
    activeBg: '#ef4444',
    activeBorder: '#ef4444',
    activeText: '#ffffff',
  },
};
